import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AdvisoryFirmApiService {
  private readonly apiUrl = '/api/advisoryfirm';

  constructor(private http: HttpClient) { }

  // Get advisory firm by ID
  getById(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`).pipe(catchError(this.handleError));
  }

  // Get all advisory firms
  getAdvisoryFirms(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}`).pipe(catchError(this.handleError));
  }

  // Get light version of advisory firms
  getAdvisoryFirmsLight(): Observable<any[]> {
    return this.http.get<any[]>('/api/servicer/getadvisoryfirmslight').pipe(catchError(this.handleError));
  }

  // Get advisory leads for company group servicer
  getAdvisoryLeadsForCompanyGroupServicer(companyGroupId: number): Observable<any[]> {
    return this.http.get<any[]>(`/api/servicer/getadvisoryleadsforcompanygroupservicer/${companyGroupId}`).pipe(catchError(this.handleError));
  }

  // Get advisory firms by company group
  getAdvisoryFirmsByCompanyGroup(companyGroupId: number): Observable<any[]> {
    return this.http.get<any[]>(`/api/servicer/getadvisoryfirmsbycompanygroup/${companyGroupId}`).pipe(catchError(this.handleError));
  }

  // Search advisory firms by name
  searchByName(searchTerm: string, companyGroupId: number): Observable<any> {
    return this.http.get<any>(`/api/servicer/searchadvisoryfirmbyname/${searchTerm}/${companyGroupId}`).pipe(catchError(this.handleError));
  }

  // Create a new advisory firm
  create(advisoryFirm: any): Observable<any> {
    return this.http.post('/api/servicer/createadvisoryfirm', advisoryFirm).pipe(catchError(this.handleError));
  }

  // Update an advisory firm
  update(advisoryFirm: any): Observable<any> {
    return this.http.post('/api/servicer/updateadvisoryfirm', advisoryFirm).pipe(catchError(this.handleError));
  }

  // Get TAMPs for an advisory firm
  getTamps(advisoryFirmId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/${advisoryFirmId}/tamps`).pipe(catchError(this.handleError));
  }

  // Get products for an advisory firm
  getProducts(advisoryFirmId: number, tampId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/${advisoryFirmId}/products?tampId=${tampId}`).pipe(catchError(this.handleError));
  }

  // Get product types for an advisory firm
  getProductTypes(advisoryFirmId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/${advisoryFirmId}/producttypes`).pipe(catchError(this.handleError));
  }

  // Get managers for an advisory firm
  getManagers(advisoryFirmId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/${advisoryFirmId}/managers`).pipe(catchError(this.handleError));
  }

  // Handle HTTP errors
  private handleError(error: HttpErrorResponse): Observable<never> {
    console.error('Error occurred:', error);
    return throwError(() => new Error('An error occurred while processing the request.'));
  }
}
